import * as Sentry from "@sentry/react"
import { QueryClientProvider } from "@tanstack/react-query"
import { RouterProvider } from "@tanstack/react-router"

import { config } from "@/utils/config"
import { QueryDevtools } from "@/utils/devtools"
import { initFaro } from "@/utils/faro"

import { router } from "./router"
import { queryClient } from "./services/queryClient"

const sentryIntegrations = import.meta.env.PROD
  ? [
      Sentry.replayIntegration({
        networkDetailAllowUrls: [window.location.origin],
        maskAllInputs: false,
        maskAllText: false,
        blockAllMedia: false,
      }),
      Sentry.replayCanvasIntegration(),
    ]
  : undefined

if (import.meta.env.VITE_SENTRY_ENABLED === "true") {
  Sentry.init({
    dsn: "https://ffb3abaedebadc2cb9fd2f1ddc3526f5@o4509807260336129.ingest.de.sentry.io/4509829763956816",
    replaysSessionSampleRate: config.SENTRY_REPLAYS_SAMPLE_RATE,
    replaysOnErrorSampleRate: 1,
    integrations: sentryIntegrations,
  })
}

// Grafana Faro runs alongside Sentry and no-ops outside deployed environments.
initFaro()

// App itself
export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <QueryDevtools />
      <RouterProvider router={router} />
    </QueryClientProvider>
  )
}
